"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchForms = void 0;
const config_1 = require("../config");
const apiFetch_1 = require("../utils/apiFetch");
const fetchForms = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const token = (0, config_1.getAuthToken)();
        const headers = {};
        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
        const json = yield (0, apiFetch_1.apiFetch)(`${process.env.REACT_APP_API_BASE_URL}/v1/question?page=1&limit=5`, {
            headers,
        });
        const items = ((_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.items) || [];
        return items.map((item) => ({
            _id: item._id,
            title: item.title,
            bannerUrl: item.bannerUrl || "/placeholder-banner.png",
            questions: item.questions || [],
        }));
    }
    catch (err) {
        console.error("Error in fetchForms:", err);
        throw err; // Let the caller handle it
    }
});
exports.fetchForms = fetchForms;
